import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadStatusReportService {


  url = environment.serverAPI9 + "/api/leadStatusReport";
  constructor(private http: HttpClient) { }

  // searchLeadStatusReport(query, Page: any, size: any, sort: any): Observable<Object> {
  //   return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  // }

  // searchLeadStatusReport(query, Page: any, size: any, sort: any): Observable<Response[]> {
  //   let object = {
  //     searchQuery: query.split("'").join('')
  //   }
  //   return this.http.post<Response[]>(`${this.url}/condition?page=${Page}&size=${size}&sort=${sort}`, object)
  // }

  searchLeadStatusReport(query: string, page: number, size: number, sort: string): Observable<Response[]> {


    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null // Remove single quotes from the query
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; // Construct query parameters

    return this.http.post<Response[]>(`${this.url}/condition${queryParams}`, requestBody);
  }

  getLeadStatusReport(Page: number, size: number, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  url2 = environment.serverAPI9 + "/api/status/user/report";

  searchDynamicLeadReport(query: string, page: number, size: number, sort: string, groupBy:any): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null ,
      "groupBy": groupBy
      
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; 

    return this.http.post<Response[]>(`${this.url2}${queryParams}`, requestBody);
  }

  searchDynamicLeadReportDash(query: string, page: number, size: number, sort: string): Observable<Response[]> {

    const requestBody = {
      "searchQuery": query != null ? query.split("'").join('') : null ,
      "groupBy": 'a.owner_id, c.email'
      
    };

    const queryParams = `?page=${page}&size=${size}&sort=${sort}`; 

    return this.http.post<Response[]>(`${this.url2}${queryParams}`, requestBody);
  }

}
